import { WIDGET_VIEW_OBJECT } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ObjectViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_OBJECT,
  component: () => import("./object-view-widget.component").then((m) => m.ObjectViewWidgetComponent)
};
